import { render, staticRenderFns } from "./RemoveIntegration.vue?vue&type=template&id=e2bc66f8&"
import script from "./RemoveIntegration.vue?vue&type=script&lang=js&"
export * from "./RemoveIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports